export default (form) => {
    if (!form.classList.contains('js-recaptcha')) return;
    
    const checkRecaptcha = (token) => {
        // insert token into form and continue with submission...
        var input = document.createElement("INPUT");
        input.setAttribute("type", "text");
        input.setAttribute("name", "recaptcha");
        input.setAttribute("value", token);
        input.classList.add('hidden');
        if (!window.test) {
            form.appendChild(input);
        }
        form.submit();
    }

    window.checkRecaptcha = checkRecaptcha;
    
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        form.querySelector('.btn').classList.add('btn--loading');
        window.grecaptcha.execute();
    })

};